import { render, staticRenderFns } from "./TUIDatepickerInput.vue?vue&type=template&id=2c3cc422&scoped=true"
import script from "./TUIDatepickerInput.vue?vue&type=script&lang=js"
export * from "./TUIDatepickerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cc422",
  null
  
)

export default component.exports